import React, { useRef, useState } from 'react';
import { Upload } from 'lucide-react';

type FileUploadProps = {
  formName?: string;
  fieldId?: string;
  value?: File | File[] | null;
  multiple?: boolean;
  accept?: string;
  onChange: (files: File | File[] | null) => void;
  label?: string;
  className?: string;
  disabled?: boolean;
  required?: boolean;
  maxSizeMB?: number;
};

const FileUpload: React.FC<FileUploadProps> = ({
  value,
  multiple = false,
  accept,
  onChange,
  label = 'Selecionar arquivo',
  className = '',
  disabled = false,
  maxSizeMB,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [error, setError] = useState<string | null>(null);

  const handleFiles = (list: FileList | null) => {
    if (!list || list.length === 0) {
      onChange(multiple ? null : null);
      return;
    }
    if (maxSizeMB) {
      const oversize = Array.from(list).find((f) => f.size > maxSizeMB * 1024 * 1024);
      if (oversize) {
        setError(`Arquivo ${oversize.name} excede ${maxSizeMB} MB`);
        return;
      }
    }
    setError(null);
    onChange(multiple ? Array.from(list) : list[0]);
  };

  const currentCount = Array.isArray(value) ? value.length : value ? 1 : 0;

  return (
    <div className={className}>
      <button
        type="button"
        disabled={disabled}
        onClick={() => inputRef.current?.click()}
        className="flex w-full items-center justify-center gap-2 rounded-lg border border-dashed border-slate-300 bg-slate-50 px-4 py-4 text-sm font-medium text-slate-600 transition hover:bg-slate-100 disabled:opacity-50 dark:border-gray-700 dark:bg-gray-900 dark:text-slate-300 dark:hover:bg-gray-800"
      >
        <Upload className="h-4 w-4" />
        {label}
        {currentCount > 0 ? (
          <span className="ml-2 rounded-full bg-brand-600 px-2 py-0.5 text-xs text-white">
            {currentCount}
          </span>
        ) : null}
      </button>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        multiple={multiple}
        disabled={disabled}
        className="hidden"
        onChange={(e) => handleFiles(e.target.files)}
      />
      {error ? (
        <div className="mt-2 text-xs text-rose-600 dark:text-rose-400">{error}</div>
      ) : null}
    </div>
  );
};

export default FileUpload;
